import { render, staticRenderFns } from "./editFgts.vue?vue&type=template&id=9cd814fe&scoped=true"
import script from "./editFgts.vue?vue&type=script&lang=ts"
export * from "./editFgts.vue?vue&type=script&lang=ts"
import style0 from "./editFgts.vue?vue&type=style&index=0&id=9cd814fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd814fe",
  null
  
)

export default component.exports